// extracted by mini-css-extract-plugin
export default {"container":"AreaTariffs_container__yEWJX","header":"AreaTariffs_header__NNSid","tariffContainer":"AreaTariffs_tariffContainer__KvXYg"};